import { createConfirmation } from "react-confirm";
import AddNewCategoryDialog from "./AddNewCategoryDialog";

export const showAddNewCategoryDialog = createConfirmation(AddNewCategoryDialog);
